var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Tabs from './tabs.vue';
var TCTabsProxy = /** @class */ (function (_super) {
    __extends(TCTabsProxy, _super);
    function TCTabsProxy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TCTabsProxy.prototype.getNodeDataAttribute = function (node, name, defaultValue) {
        if (node.data != null && node.data.attrs != null) {
            return node.data.attrs[name];
        }
        return defaultValue != null ? defaultValue() : undefined;
    };
    TCTabsProxy.prototype.render = function (createElement) {
        var tabs = [];
        var defaultTabId = null;
        var tabIndex = 0;
        for (var _i = 0, _a = this.$slots.default; _i < _a.length; _i++) {
            var node = _a[_i];
            if (node.tag === 'tab') {
                var id = this.getNodeDataAttribute(node, 'id', function () { return ++tabIndex; });
                var header = node.children.find(function (o) { return o.tag === 'header'; });
                var content = node.children.find(function (o) { return o.tag === 'content'; });
                var tab = {
                    id: id,
                    header: header,
                    content: content,
                };
                if (this.getNodeDataAttribute(node, 'default') != null) {
                    defaultTabId = id;
                }
                tabs.push(tab);
            }
        }
        return createElement(Tabs, __assign(__assign({}, this.$vnode.data), { props: {
                tabs: tabs,
                id: this.id,
                default: defaultTabId,
            } }));
    };
    __decorate([
        Prop({ type: String })
    ], TCTabsProxy.prototype, "id", void 0);
    TCTabsProxy = __decorate([
        Component({
            components: {},
        })
    ], TCTabsProxy);
    return TCTabsProxy;
}(Vue));
export default TCTabsProxy;
